import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"
import { cn } from "@/lib/utils"

interface SafetyBadgeProps {
	rating?: "green" | "amber" | "red" | "gray"
	score?: number
	size?: "sm" | "default"
}

export function SafetyBadge({ size = "default" }: SafetyBadgeProps) {
	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<span
					tabIndex={0}
					className={cn(
						"inline-flex items-center gap-1.5 cursor-default",
						size === "sm" ? "text-xs" : "text-sm",
					)}
				>
					<span
						className={cn(
							"rounded-full flex-shrink-0 bg-muted-foreground/30",
							size === "sm" ? "w-2 h-2" : "w-2.5 h-2.5",
						)}
					/>
					<span className="font-medium text-muted-foreground italic">Soon</span>
				</span>
			</TooltipTrigger>
			<TooltipContent>Dividend safety scores — coming soon</TooltipContent>
		</Tooltip>
	)
}
